import type { SessionSnapshot } from '../lib/sessionStore';

interface Props {
  snapshot: SessionSnapshot;
  onResume: () => void;
  onDiscard: () => void;
}

export function PriorSweepResumePrompt({ snapshot, onResume, onDiscard }: Props) {
  return (
    <div
      role="dialog"
      aria-label="Resume previous sweep"
      className="space-y-3 rounded-md bg-blue-900/40 px-4 py-3 text-sm text-blue-100 ring-1 ring-blue-700"
      data-testid="resume-prompt"
    >
      <p className="font-medium">
        Resume previous sweep? {snapshot.dedupe.size} bin
        {snapshot.dedupe.size === 1 ? '' : 's'} already scanned.
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onResume}
          className="rounded-md bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-500"
          data-testid="resume-button"
        >
          Resume
        </button>
        <button
          type="button"
          onClick={onDiscard}
          className="rounded-md bg-gray-800 px-3 py-1.5 text-xs text-gray-300 hover:bg-gray-700"
          data-testid="discard-button"
        >
          Start fresh
        </button>
      </div>
    </div>
  );
}
